import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ProjectPageLayout from '@adsk/alloy-project-page-layout';
import getCurrentProductIdFromURL from '../utils/getCurrentProductIdFromURL';
import getCurrentToolIdFromURL from '../utils/getCurrentToolIdFromURL';
import isExoRoute from '../utils/isExoRoute';
import safeGetPathname from '../utils/safeGetPathname';
import AlloyContextSubscriber from './AlloyContextSubscriber';
import LocalSideNavigation from './LocalSideNavigation/LocalSideNavigation';

const mapToolIdToRedirectToProductIds = {};

const RootProjectPageLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toolId = getCurrentToolIdFromURL(location);
  const productId = getCurrentProductIdFromURL(location);

  return (
    <ProjectPageLayout
      isUsersConstructionApi
      currentProductId={productId}
      currentToolId={toolId === 'demo-app' ? 'rfis' : toolId}
      renderSideNavigation={(props) => (
        <LocalSideNavigation {...props} selectedId={toolId} />
      )}
      redirectToProductIds={mapToolIdToRedirectToProductIds[toolId]}
      onProductClick={({ url }) => {
        const pathname = safeGetPathname(url);

        if (isExoRoute(url)) {
          navigate(pathname);
        } else {
          window.location.assign(url);
        }
      }}
    >
      <AlloyContextSubscriber>
        <Outlet />
      </AlloyContextSubscriber>
    </ProjectPageLayout>
  );
};

export default RootProjectPageLayout;
